(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["regis-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    // La clase .regis-anim-on ya la puso (o no) el script inline del <head>,
    // que comprueba soporte de IntersectionObserver y prefers-reduced-motion.
    if (!document.documentElement.classList.contains('regis-anim-on')) return;
    if (!('IntersectionObserver' in window)) return;

    var SELECTOR = [
      '.regis-card', '.regis-pcard', '.regis-blog-card', '.regis-comp__fact',
      '.regis-ocombo', '.regis-benefit', '.regis-ingredient',
      '.regis-trust__item', '.regis-coll__trust-item', '.regis-incluye__item'
    ].join(',');

    function reveal(el) { el.classList.add('is-visible'); }

    function init() {
      var els = document.querySelectorAll(SELECTOR);
      if (!els.length) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

      els.forEach(function (el) {
        // Escalonado ligero según la posición del elemento en su fila (máx ~5).
        var index = 0;
        if (el.parentElement) {
          index = Array.prototype.indexOf.call(el.parentElement.children, el);
        }
        var delay = Math.min(index, 5) * 60;
        el.style.transitionDelay = delay + 'ms';
        io.observe(el);
      });

      // Red de seguridad: si algo falla, revela todo a los 3s (nunca contenido oculto).
      setTimeout(function () {
        els.forEach(function (el) {
          if (!el.classList.contains('is-visible')) reveal(el);
        });
      }, 3000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
